// extracted by mini-css-extract-plugin
export default {"layout":"hKlUbjaA","content":"pMfMNDMD","container":"a4A7y39K","logo":"KV1J6J0C","fallbackContent":"w64ZtpUI","isMobile":"BZh9nIQE","isTablet":"aM_jMOGN","isDesktop":"yq7PVMN2"};